import { useEffect } from 'react';

import { ampli } from '~entities/ampli';
import type { FindPaymentsRequestParams } from '~entities/payment';
import { useGenerateReportMutation } from '~entities/payment';
import { isReportGenerated } from '~entities/payment/lib/is-report-generated';
import {
  useCheckReportStatusQuery,
  useDownloadReportQuery,
} from '~entities/report';

import DownloadIcon from '~shared/assets/icons/download.svg?react';

import { Button } from '@breezeventures/ui-kit/button';

export const PaymentsExport = ({
  params,
  disabled,
  size = 'm',
}: {
  params?: FindPaymentsRequestParams;
  disabled?: boolean;
  size?: 's' | 'm';
}) => {
  const generateReportMutation = useGenerateReportMutation();
  const checkStatusQuery = useCheckReportStatusQuery(
    generateReportMutation.data?.reportId
  );
  const downloadQuery = useDownloadReportQuery({
    reportData: checkStatusQuery.data,
    screen: 'payments',
  });

  useEffect(() => {
    if (downloadQuery.isSuccess) {
      generateReportMutation.reset();
    }
  }, [downloadQuery.isSuccess, generateReportMutation]);

  const handleExportClick = () => {
    if (!params) return;
    generateReportMutation.mutate(params);
    ampli.paymentsScreenTapExport();
  };
  const reportGenerationInProgress =
    generateReportMutation.isSuccess &&
    !isReportGenerated(checkStatusQuery.data);
  const downloadInProgress =
    isReportGenerated(checkStatusQuery.data) && downloadQuery.isLoading;

  const showLoader =
    generateReportMutation.isPending ||
    reportGenerationInProgress ||
    downloadInProgress;

  return (
    <Button
      type="button"
      size={size}
      variant="secondary"
      loading={showLoader}
      disabled={showLoader || disabled || !params}
      onClick={handleExportClick}
    >
      {!showLoader && (
        <Button.Icon>
          <DownloadIcon />
        </Button.Icon>
      )}
      Export to Excel
    </Button>
  );
};
